import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useAuth } from 'hooks/useAuth';
import { redirectToSsoLogin, redirectToSsoSignup } from 'common/utils/auth';
import './Login.css';

export const Login = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { isAuthenticated, isLoading } = useAuth();

    // 로그인 후 돌아갈 URL (기본값: /home)
    const returnUrl = searchParams.get('returnUrl') || '/home';

    useEffect(() => {
        // 이미 로그인되어 있으면 홈으로 이동
        if (!isLoading && isAuthenticated) {
            navigate(returnUrl, { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate, returnUrl]);

    const handleLogin = () => {
        // 현재 앱의 returnUrl로 리다이렉트될 수 있도록 설정
        const fullReturnUrl = window.location.origin + returnUrl;
        redirectToSsoLogin(fullReturnUrl);
    };

    const handleSignup = () => {
        const fullReturnUrl = window.location.origin + returnUrl;
        redirectToSsoSignup(fullReturnUrl);
    };

    if (isLoading) {
        return (
            <div className="login-wrapper">
                <div className="login-loading">로딩 중...</div>
            </div>
        );
    }

    return (
        <div className="login-wrapper">
            <div className="login-content">
                <div className="login-logo">
                    <h1>MOI</h1>
                    <p>모임을 더 쉽게, 더 즐겁게</p>
                </div>

                <div className="login-buttons">
                    <button
                        className="login-btn login-btn-primary"
                        onClick={handleLogin}
                    >
                        로그인
                    </button>
                    <button
                        className="login-btn login-btn-secondary"
                        onClick={handleSignup}
                    >
                        회원가입
                    </button>
                </div>

                <div className="login-footer">
                    <span className="login-footer-text">
                        로그인하면 서비스 이용약관에 동의하게 됩니다.
                    </span>
                </div>
            </div>
        </div>
    );
};
